import {
  Stack,
  Avatar,
  TableRow,
  MenuItem,
  TableCell,
  Typography,
  // IconButton,
  ListItemText,
  // CircularProgress,
} from '@mui/material';
import Decimal from 'decimal.js';

// import Label from 'src/components/label';
import { useBoolean } from 'src/hooks/use-boolean';
import { PositionTxType } from 'src/type/position';
import { TransactionType } from 'src/type/transaction';
import { fNumber } from 'src/utils/format-number';
import { fDate, fTime } from 'src/utils/format-time';
import Iconify from 'src/components/iconify';
import { shortString } from 'src/utils/format-string';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
// import { BranchType } from 'src/type/branch';
// import axios, { endpoints } from 'src/utils/axios';
// import { enqueueSnackbar } from 'notistack';
import { convertGold } from 'src/utils/convert';
// import SellApproveDialog from './sell-position-approve-dialog';
// import RejectDialog from './position-reject-dialog';
// import BuyApproveDialog from './buy-position-approve-dialog';
// import PositionViewDialog from './position-view-dialog';
// import CancelDialog from './position-cancel-dialog';
// import { txStatusLabel } from './utils';

type Props = {
  row: PositionTxType;
  // branches: BranchType[];
};

export default function StockTableRow({ row }: Props) {
  const popover = usePopover();
  // const sellApprove = useBoolean();
  // const buyApprove = useBoolean();
  // const cancel = useBoolean();
  // const reject = useBoolean();
  const view = useBoolean();

  const sending = useBoolean(false);

  const { id, createdAt, type, amount, user, pricePerUnit, priceDifferencePerUnit, unitName } = row;

  // pricePerUnit คือราคา/บาท
  // finalPricePerUnit = pricePerUnit + priceDifferencePerUnit
  const finalPricePerUnit = new Decimal(pricePerUnit || 0)
    .plus(priceDifferencePerUnit || 0)
    .toNumber();

  const amountGrams = () => {
    if (unitName === 'บาท') {
      return convertGold(amount, 'weightGrams');
    }

    return amount;
  };

  const amountBaht = () => {
    if (unitName === 'กรัม') {
      return convertGold(amount, 'weightBaht');
    }

    return amount;
  };

  // คำนวณ totalPrice
  // ถ้า unitName = 'กรัม': finalPricePerUnit * 0.0656 * amount
  // ถ้า unitName = 'บาท': finalPricePerUnit * amount
  const totalPrice =
    unitName === 'กรัม'
      ? new Decimal(finalPricePerUnit).times(0.0656).times(amount).toNumber()
      : new Decimal(finalPricePerUnit).times(amount).toNumber();

  return (
    <>
      <TableRow>
        <TableCell align="center">
          {type === TransactionType.BUY_POSITION && (
            <Typography variant="body2">ตัดซื้อ</Typography>
          )}
          {type === TransactionType.SELL_POSITION && (
            <Typography variant="body2">ตัดขาย</Typography>
          )}
          {type === TransactionType.DEPOSIT && <Typography variant="body2">ฝากสินค้า</Typography>}
          {type === TransactionType.REDEEM && <Typography variant="body2">ถอนสินค้า</Typography>}
        </TableCell>
        <TableCell>
          <Stack direction="row" alignItems="center">
            <Avatar alt="" sx={{ mr: 2 }}>
              {user?.firstName?.[0].toUpperCase()}
            </Avatar>

            <ListItemText
              disableTypography
              primary={
                <Typography variant="body2" noWrap>
                  {user?.firstName} {user?.lastName}
                </Typography>
              }
              secondary={
                <Typography variant="caption" color="text.secondary" noWrap>
                  #{shortString(id)}
                </Typography>
              }
            />
          </Stack>
        </TableCell>

        <TableCell align="left">
          <Typography variant="body2">{fNumber(finalPricePerUnit)}</Typography>
        </TableCell>

        {/* <TableCell align="left">
          <Typography variant="body2">{fNumber(pricePerUnitGram())}</Typography>
        </TableCell> */}

        <TableCell align="left">
          <Typography
            variant="subtitle1"
            // color={type === TransactionType.BUY_POSITION ? 'error.main' : 'success.main'}
          >
            {fNumber(amountBaht())}
          </Typography>
        </TableCell>

        <TableCell align="left">
          <Typography
            variant="subtitle1"
            // color={type === TransactionType.BUY_POSITION ? 'error.main' : 'success.main'}
          >
            {fNumber(amountGrams())}
          </Typography>
        </TableCell>

        <TableCell align="left">
          <Typography variant="body2" noWrap>
            {fNumber(totalPrice || 0)}
          </Typography>
        </TableCell>

        {/* <TableCell align="left">
          <Typography variant="body2" noWrap>
            {fNumber(stockCost || 0)}
          </Typography>
        </TableCell>

        <TableCell align="left">
          <Typography variant="body2" noWrap>
            {fNumber(stockProfit || 0)}
          </Typography>
        </TableCell> */}

        <TableCell>
          <ListItemText
            primary={fDate(createdAt, 'DD MMMM BBBB')}
            secondary={fTime(createdAt)}
            primaryTypographyProps={{ typography: 'body2', noWrap: true }}
            secondaryTypographyProps={{
              mt: 0.5,
              component: 'span',
              typography: 'caption',
            }}
          />
        </TableCell>

        {/* <TableCell>
          <Label
            variant="soft"
            color={
              (status === TransactionStatus.SUCCESS && 'success') ||
              (status === TransactionStatus.PENDING && 'warning') ||
              (status === TransactionStatus.REJECTED && 'error') ||
              (status === TransactionStatus.CANCEL && 'info') ||
              (status === TransactionStatus.WAITING && 'secondary') ||
              'default'
            }
          >
            {txStatusLabel(status)}
          </Label>
        </TableCell> */}

        {/* <TableCell>
          {status === TransactionStatus.SUCCESS || status === TransactionStatus.REJECTED ? (
            <ListItemText
              primary={fDate(updatedAt, 'DD MMMM BBBB')}
              secondary={fTime(updatedAt)}
              primaryTypographyProps={{ typography: 'body2', noWrap: true }}
              secondaryTypographyProps={{
                mt: 0.5,
                component: 'span',
                typography: 'caption',
              }}
            />
          ) : (
            '-'
          )}
        </TableCell> */}

        {/* <TableCell>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell> */}
      </TableRow>

      <CustomPopover
        open={popover.open}
        onClose={sending.value ? undefined : popover.onClose}
        arrow="top-right"
        sx={{ width: 160 }}
      >
        <MenuItem
          onClick={() => {
            popover.onClose();
            view.onTrue();
          }}
        >
          <Iconify icon="solar:info-square-bold" />
          รายละเอียด
        </MenuItem>
      </CustomPopover>

      {/* {buyApprove.value && (
        <BuyApproveDialog
          open={buyApprove.value}
          onClose={buyApprove.onFalse}
          handleReload={handleReload}
          tx={row}
          branches={branches}
        />
      )}

      {sellApprove.value && (
        <SellApproveDialog
          open={sellApprove.value}
          onClose={sellApprove.onFalse}
          handleReload={handleReload}
          tx={row}
          branches={branches}
        />
      )}

      {reject.value && (
        <RejectDialog
          open={reject.value}
          onClose={reject.onFalse}
          handleReload={handleReload}
          tx={row}
        />
      )}

      {cancel.value && (
        <CancelDialog
          open={cancel.value}
          onClose={cancel.onFalse}
          handleReload={handleReload}
          tx={row}
        />
      )}

      {view.value && <PositionViewDialog open={view.value} onClose={view.onFalse} tx={row} />} */}
    </>
  );
}
